// Client Rate Browser — the client-facing rate estimator.
//
// Same shipment form as the admin surface, but:
//   • Ship From is READ-ONLY (locked to the OPS 3PL Rosebery warehouse — the
//     client can't change origin; the server pins it regardless).
//   • The results table shows the marked-up price ONLY. carrier_cost and
//     margins are censored server-side and never rendered here.

import { useState } from 'react'
import RateQuoteForm from '../../../components/rate-estimator/RateQuoteForm'
import RateResultsTable from '../../../components/rate-estimator/RateResultsTable'
import { ToastContainer, useToast } from '../../../components/Toast'
import { getMeRateQuote } from '../../../lib/api'

export default function RateBrowserTab({ clientId }) {
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const { toasts, addToast, removeToast } = useToast()

  async function handleSubmit(payload) {
    if (!clientId) return
    setLoading(true)
    setResult(null)
    try {
      // ship_from is intentionally omitted — the server always uses Rosebery.
      const data = await getMeRateQuote(clientId, payload)
      setResult(data)
      if ((data.rates || []).length === 0 && (data.errors || []).length === 0) {
        addToast({ type: 'info', message: 'No rates returned for this shipment.' })
      }
    } catch (err) {
      addToast({
        type: 'error',
        message: err.response?.data?.detail || err.message || 'Failed to fetch rates.',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="space-y-5">
      <div className="card p-5">
        <h3 className="text-sm font-semibold text-slate-700 mb-1">Estimate a shipment</h3>
        <p className="text-xs text-slate-400 mb-4">
          Enter a parcel and destination to see live prices across our carriers.
          Everything ships from our Rosebery warehouse.
        </p>
        <RateQuoteForm
          onSubmit={handleSubmit}
          loading={loading}
          editableOrigin={false}
        />
      </div>

      {result && (
        <RateResultsTable
          rates={result.rates || []}
          errors={result.errors || []}
          showCost={false}
        />
      )}

      <ToastContainer toasts={toasts} onClose={removeToast} />
    </div>
  )
}
